import React from 'react'

import { H, THProps } from 'elements/text/H'

import { useTitle } from 'general/hooks/useTitle'

export type TPageTitleProps = THProps & { visibleOnMobile?: boolean }

export const PageTitle: TFCC<TPageTitleProps> = ({
  children,
  visibleOnMobile,
  color = 'darkBlue',
  fontSize = { xs: '1.6em', sm: '2em', md: '2.5em' },
  invisible,
  ...otherProps
}) => {
  const title = useTitle()

  return (
    <H color={color} fontSize={fontSize} invisible={invisible ?? (!visibleOnMobile ? 'xs' : undefined)} {...otherProps}>
      {children || title}
    </H>
  )
}
